module.exports = __webpack_public_path__ + "static/media/38_A.68c3e4bd.png";